import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { captureOpenAiAttribution, OPENAI_CONSENT_CHANGED } from './index'

export default function useOpenAiAttribution() {
  const router = useRouter()
  useEffect(() => {
    const capture = () => captureOpenAiAttribution(window.location.search)
    capture()
    window.addEventListener(OPENAI_CONSENT_CHANGED, capture)
    return () => {
      window.removeEventListener(OPENAI_CONSENT_CHANGED, capture)
    }
  }, [router.asPath])
}
